import Swiper from "swiper"
import { Navigation } from 'swiper/modules'

export const events = () => {
	// calendarNavigation()
	calendarFilter()
	// calendarToggle()
	categoryDropdownFilter()
	// waitingList()
	// registerInterest()
	// swiperRelatedEvents()
	// swiperAccreditations()
}

const calendarFilter = () => {

	let wrapper = document.querySelector('[data-el="events-archive"]')

	if (!wrapper) return false

	let items = wrapper.querySelectorAll('[data-filter-event]'),
		events = wrapper.querySelectorAll('[data-event-id]')

	items.forEach(item => {
		item.addEventListener('click', () => {
			events.forEach(event => {
				if (event.getAttribute('data-event-id') == item.getAttribute('data-filter-event')) {
					event.style.display = 'block'
				} else {
					event.style.display = 'none'
				}
			})
			resetCategoryDropdown()
		})
	})
}

const calendarToggle = () => {

	let wrapper = document.querySelector('[data-el="events-archive"]')

	if (!wrapper) return false

	let toggle = wrapper.querySelector('[data-available-toggle]'),
		carousel = wrapper.querySelector('[data-calendar-carousel]')

	toggle.addEventListener('change', () => {
		if (toggle.checked) {
			carousel.setAttribute('data-availablility-toggle', 'checked')
		} else {
			carousel.removeAttribute('data-availablility-toggle')
		}
	})
}

const categoryDropdownFilter = () => {

	let wrapper = document.querySelector('[data-el="events-archive"]')

	if (!wrapper) return false

	let dropdown = wrapper.querySelector('[data-el="events-filter"]'),
		items = wrapper.querySelectorAll('[data-event-id]')

	dropdown.addEventListener('change', () => {
		items.forEach(item => {
			let findClass = 'category-' + dropdown.value
			if (findClass == 'category-all' || item.classList.contains(findClass)) {
				item.style.display = 'block'
			} else {
				item.style.display = 'none'
			}
		})
	})
}

const resetCategoryDropdown = () => {
	let dropdown = document.querySelector('.categories-dropdown')
	dropdown.value = 'none'
}

const waitingList = () => {

	let buttons = document.querySelectorAll('[data-waiting-list]'),
		hiddenField = document.querySelector('.event-hidden-field'),
		dateField = document.querySelector('.event-date-field')

	if (!buttons.length || !hiddenField) return false

	buttons.forEach(button => {
		button.addEventListener('click', () => {

			let title = button.getAttribute('data-waiting-list'),
				date = button.getAttribute('data-waiting-list-data')

			hiddenField.value = title
			dateField.value = date

		})
	})
}

const registerInterest = () => {

	let buttons = document.querySelectorAll('[data-register-interest]'),
		hiddenField = document.querySelector('.register-interest-hidden-field'),
		dateField = document.querySelector('.register-interest-date-field'),
		interestFields = document.querySelectorAll('.interest-options input')

	if (!buttons.length || !hiddenField) return false

	buttons.forEach(button => {
		button.addEventListener('click', () => {

			let title = button.getAttribute('data-register-interest'),
				date = button.getAttribute('data-register-interest-date'),
				interestsString = button.getAttribute('data-interests')

			let interests = interestsString.split(',');

			interestFields.forEach((interestField, i) => {
				if (interests[i] && interests[i] !== '') {
					interestField.parentElement.parentElement.style.display = 'block'
					interestField.value = interests[i]
					interestField.nextElementSibling.innerHTML = interests[i]
				} else {
					interestField.parentElement.parentElement.style.display = 'none'
				}
			})

			hiddenField.value = title
			dateField.value = date

		})
	})
}


const swiperRelatedEvents = () => {

	let el = document.querySelector('[data-swiper="related-events"]');

	if (!el) return

	new Swiper(el, {
		spaceBetween: 20,
		loop: true,
		navigation: {
			nextEl: '.related-button-next',
			prevEl: '.related-button-prev',
		},
	})

}

const swiperAccreditations = () => {

	let el = document.querySelector('[data-swiper="accreditations"]');

	if (!el) return

	new Swiper(el, {
		spaceBetween: 20,
		loop: true,
		navigation: {
			nextEl: '.accreditations-button-next',
			prevEl: '.accreditations-button-prev',
		},
		slidesPerView: 1,
		breakpoints: {
			600: {
				slidesPerView: 2,
			},
			960: {
				slidesPerView: 3,
			},
		}
	})

}

export default () => { }